import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  FormControl,
  Select,
  MenuItem,
  Button,
  Stack,
} from "@mui/material";
import Close from "../../../assets/icons/Close.svg";
import { getQuestionChecklistMastersList } from "../../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const ViewChecklistModel = (Props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);

  useEffect(() => {
    dispatch(
      getQuestionChecklistMastersList({
        id: Props?.ChecklistRowData?.id,
      })
    );
  }, []);

  const checklistQuestionMasterData = useSelector(
    (state) => state?.masters?.checklistQuestionMasterData
  );

  return (
    <Modal
      open={Props.isViewChecklistModel}
      onClose={() => Props.handleCloseViewChecklistModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              {Props?.ChecklistRowData?.name}
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={Props.handleCloseViewChecklistModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box sx={{ marginBottom: "15px" }}>
            <Typography
              sx={{ color: "#B5B5C3", fontSize: "14px", fontWeight: 600 }}
            >
              Checklist Question
            </Typography>
          </Box>
          <Divider sx={{ marginBottom: "15px" }} />
          <Grid
            sx={{
              // marginBottom: "25px",
              overflow: "auto",
              height: "25rem",
              padding: "0px 10px 0px 10px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {isLoading ? (
              <Grid item xs={12}>
                <Stack
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "25rem",
                  }}
                >
                  <CircularProgress color="success" />
                </Stack>
              </Grid>
            ) : (
              checklistQuestionMasterData?.map((row, index) => (
                <Grid item xs={12} key={row?.id}>
                  <Stack direction="row" alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "5px 0px 5px 0px",
                        width: "100%",
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          align="center"
                          sx={{
                            fontSize: "14px",
                            color: "#464E5F",
                            fontWeight: 600,
                            paddingRight: "10px",
                          }}
                        >
                          Q{index + 1}:{" "}
                        </Typography>
                        <Typography
                          align="left"
                          sx={{
                            fontSize: "15px",
                            color: "#212121",
                            fontWeight: 550,
                          }}
                        >
                          {row?.question}
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                  <Divider sx={{ paddingTop: "10px" }} />
                </Grid>
              ))
            )}
          </Grid>
          <Divider sx={{ marginBottom: "10px" }} />
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            {/* <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={Props.handleEditChecklistModel}
              >
                Edit
              </Button>
            </Box> */}
            <Box>
              <Button
                // variant="contained"
                onClick={Props.handleCloseViewChecklistModel}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
              >
                Okay
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewChecklistModel;
